import { DisplayAreas } from "src/enums";
import { BottomSheetState } from "src/features/promotions/promoBottomSheet/state/bottomSheetSlice";

export const bottomSheetSelectors = {
  getBottomSheetByArea: (state: BottomSheetState, displayArea: DisplayAreas) =>
    state.items.find((message) => message.displayAreas?.includes(displayArea)),
};
